export default __webpack_public_path__ + "static/media/CV.3ea8b0f7.pdf";